import React, { useEffect, useState } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";

import iconeNfe from "../images/page-icon.svg";
import iconeCertificado from "../images/certificate-icon.svg";
import "../styles/pages/detgrid.css";

import DetEntrega from "./DetEntrega";
import { logEntregaProps } from "../interfaces/index";
import { MouseEvent } from "react";

import api from "../services/api";

import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import { red, blue } from '@material-ui/core/colors';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import IconArrowDown from '../images/arrow-down.svg';
import { te } from "date-fns/locale";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
  })
);

interface PropriedadesDetGrid {
  logsEntrega: Array<logEntregaProps>;
  codigo?: string;
}

export default function DetGrid(props: PropriedadesDetGrid) {
  const classes = useStyles();

  const [search, setSearch] = useState(Boolean);
  const [link, setLink] = useState("");
  const [target, setTarget] = useState("");
  const [display, setDisplay] = useState("none");
  const [displayButton, setDisplayButton] = useState("flex");
  const [displaySearch, setDisplaySearch] = useState("none");
  const [hasRemoteNfe, setHasRemoteNfe] = useState<boolean>(false);

  let cnpjsToNFE = ['26796309000123',  /* zeni */
    '34859169000202',  /* juma */
    '10935713000109', /* eco */
    '10474874000134', /* trip */
    '34859169000113', /* juma comercio */
    '10406052000116' /* gaia */
  ]

  async function getNFE(e: MouseEvent, chave: Number, chItemPed: Number, transportadora: String) {
    if (link !== "") return
    try {
      e.preventDefault();
      handleButtonNota(true, false);
      const response = await api.post("/linknfe", { chave, chItemPed, transportadora });
      handleButtonNota(false, false);

      if (response.data.nfe) {
        handleButtonNota(false, true);
        setLink(response.data.nfe)
        window.open(response.data.nfe)
      } else {
        handleButtonNota(false, false);

      }
    } catch (error) {
      setLink("")
      setTarget("")
      setDisplay("flex")
      setDisplayButton("none")
    }
  }

  function handleButtonNota(type: Boolean, hasLink: Boolean) {
    if (type == true) {
      setSearch(true);
      setDisplaySearch("flex");
      setDisplayButton("none");
    } else {
      if (hasLink) {
        setTarget("_blank");
        setDisplay("none");
        setDisplayButton("flex");
      } else {
        setSearch(false);
        setTarget("");
        setDisplay("flex");
        setDisplayButton("none");
        setDisplaySearch("none");
      }
    }
  }

  function isFaturado() {
    let orderFat = {
      isFat: false,
      index: 0,
    };

    props.logsEntrega.map((logEntrega, index) => {
      if (logEntrega.chNFE) {
        orderFat.isFat = true;
        orderFat.index = index;
      }
    });

    return orderFat;
  }

  function getCnpjs() {
    return cnpjsToNFE.find((el) => el == props.logsEntrega[isFaturado().index].cnpjEmissorNFE)
  }

  const faturado = isFaturado();
  const [linkCert, setLinkCert] = useState<string>("");
  let temCertificado = false;

  useEffect(() => {
    let mounted = true;

    const fetchCert = async () => {
      if (!faturado.isFat) {
        if (mounted) setLinkCert("");
        return;
      }

      try {
        const code = props.codigo ? props.codigo.toLowerCase() : "";
        if (!code) {
          if (mounted) setLinkCert("");
          return;
        }
        const response = await api.get(`/linkCertificado/${code}`);
        const data = response?.data;
        let certificado = "";
        if (Array.isArray(data)) {
          certificado = data[0]?.certificado ?? data[0]?.link ?? "";
        } else if (data && typeof data === 'object') {
          certificado = data.certificado ?? data.link ?? "";
        }
        console.log("certificado extraido:", certificado);
        if (mounted) setLinkCert(certificado);
      } catch (err) {
        if (mounted) setLinkCert("");
      }
    };

    fetchCert();

    return () => {
      mounted = false;
    };
  }, [faturado.isFat, faturado.index, props.codigo, props.logsEntrega]);

  useEffect(() => {
    let mounted = true;

    const fetchNfe = async () => {
      if (!faturado.isFat) {
        if (mounted) setHasRemoteNfe(false);
        return;
      }

      const log = props.logsEntrega[faturado.index];
      if (!log) {
        if (mounted) setHasRemoteNfe(false);
        return;
      }

      try {
        const chave = log.chave;
        const chItemPed = log.chItemPed;
        const transportadora = log.transportadora;
        const response = await api.post('/linknfe', { chave, chItemPed, transportadora });
        const exists = Boolean(response?.data?.nfe);
        if (mounted) setHasRemoteNfe(exists);
      } catch (err) {
        if (mounted) setHasRemoteNfe(false);
      }
    };

    fetchNfe();

    return () => {
      mounted = false;
    };
  }, [faturado.isFat, faturado.index, props.logsEntrega]);

  return (
    <div className={classes.root}>
      <div className="detgrid-main">
        <DetEntrega logsEntrega={props.logsEntrega} />
      </div>
      <div className="detgrid-footer">
        {isFaturado().isFat && props.logsEntrega[0].descricao !== "Cancelado" && (
          <div className="detgrid-nfe">
            {props.logsEntrega[isFaturado().index].linkNFE && (
              <a
                href={props.logsEntrega[isFaturado().index].linkNFE}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={iconeNfe} alt="nfe"></img>
                VISUALIZAR <br />
                NOTA FISCAL
              </a>
            )}
            {!props.logsEntrega[isFaturado().index].linkNFE && getCnpjs() && (
              <a style={{ display: displayButton }} href={link} target={target}
                onClick={(e) => getNFE(e, props.logsEntrega[isFaturado().index].chave, props.logsEntrega[isFaturado().index].chItemPed, props.logsEntrega[isFaturado().index].transportadora)}
              >
                <img src={iconeNfe} alt="nfe"></img>
                VISUALIZAR <br />
                NOTA FISCAL
              </a>
            )}
            <div className="detgrid-searchingNota" style={{ display: displaySearch }}>
              <InfoIcon style={{ color: blue[500] }}></InfoIcon>
              <span>Buscando...</span>
            </div>
            <div className="detgrid-errorNota" style={{ display: display }}>
              <ErrorIcon style={{ color: red[500] }}></ErrorIcon>
              <span>ERRO AO BUSCAR NOTA</span>
            </div>
          </div>
        )}
        {linkCert && (
          <div className="detgrid-certificado">
            {linkCert ? (
              <a
                style={{ display: displayButton }}
                href={linkCert}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={iconeCertificado} alt="certificado"></img>
                CERTIFICADO <br />
                DE GARANTIA
              </a>
            ) : (
              <a
                style={{ display: displayButton, cursor: 'pointer' }}
                href="#"
              >
                <img src={iconeCertificado} alt="certificado"></img>
                CERTIFICADO <br />
                DE GARANTIA
              </a>
            )}
            <div className="detgrid-searchingNota" style={{ display: displaySearch }}>
              <InfoIcon style={{ color: blue[500] }}></InfoIcon>
              <span>Buscando...</span>
            </div>
            <div className="detgrid-errorNota" style={{ display: display }}>
              <ErrorIcon style={{ color: red[500] }}></ErrorIcon>
              <span>ERRO AO BUSCAR CERTIFICADO</span>
            </div>
          </div>
        )}
      </div>
      {isFaturado().isFat && props.logsEntrega[0].descricao !== "Cancelado" && (
        <div className="detgrid-transportadora">
          <span>transportadora</span>
          <a
            href={props.logsEntrega[isFaturado().index].linkRastreioTransp}
            target="_blank"
            rel="noreferrer noopener"
          >
            <p>{props.logsEntrega[isFaturado().index].codigo}</p>
          </a>
        </div>
      )}
    </div>
  );
}
